const sns = () => {
  const twitterBtn = document.querySelectorAll('.js-twitter');
  const fbBtn = document.querySelectorAll('.js-facebook');
  // const lineBtn = document.querySelectorAll('.js-line');

  for (let ctr = 0; ctr < twitterBtn.length; ctr++) {
    twitterBtn[ctr].addEventListener('click', e => {
      e.preventDefault();
      window.open('https://twitter.com/share?text=helloworld', '_blank', 'width=550,height=420').focus();
    });
  }

  for (let ctr = 0; ctr < fbBtn.length; ctr++) {
    fbBtn[ctr].addEventListener('click', e => {
      e.preventDefault();
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.host}`, '_blank', 'width=550,height=420').focus();
    });
  }

  // for (let ctr = 0; ctr < lineBtn.length; ctr++) {
  //   lineBtn[ctr].addEventListener('click', e => {
  //     e.preventDefault();
  //     window.open(`line://msg/text/${window.location.host}`, '_blank', 'width=550,height=420').focus();
  //   });
  // }
}

export default sns;